module.exports = __webpack_public_path__ + "img/turks-DE.689c2efd.png";